/* ============================================================
   MONMOUTH CARDS — RELEASE DAY (assets/mc-release-day.js)
   Progressive enhancement over server-rendered Liquid:
   - deep links: #bowman #big-league-chew #tennis #star-wars #breaks  +  ?focus=
   - UTMs preserved on every outbound link + stamped on the cart (_rd_* attributes)
   - live stock refresh for product cards and break boards (/products/<handle>.js)
   - multi-team break selection → one /cart/add.js call
   ============================================================ */
(function () {
  'use strict';
  var root = document.getElementById('mcRD');
  if (!root || root.dataset.rdInit) return;
  root.dataset.rdInit = '1';

  var POLL = (parseInt(root.dataset.poll, 10) || 45) * 1000;
  var PAGE_KEY = root.dataset.pageKey || 'release-day';
  var CART_URL = root.dataset.cartUrl || '/cart';
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var money = function (cents) {
    // /products/<handle>.js returns prices in the visitor's market currency, so label them with that currency
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (cur) { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) {} }
    if (window.Shopify && Shopify.formatMoney) { try { return Shopify.formatMoney(cents); } catch (e) {} }
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* ── Campaign tracking ── */
  var qs = new URLSearchParams(location.search);
  var UTM = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (qs.get(k)) UTM[k] = qs.get(k); });
  try {
    if (Object.keys(UTM).length) sessionStorage.setItem('mcRdUtm', JSON.stringify(UTM));
    else UTM = JSON.parse(sessionStorage.getItem('mcRdUtm') || '{}');
  } catch (e) {}
  var ALIAS = { 'bowman': 'bowman', 'bowman-football': 'bowman', 'blc': 'big-league-chew', 'big-league-chew': 'big-league-chew',
    'tennis': 'tennis', 'star-wars': 'star-wars', 'starwars': 'star-wars', 'breaks': 'breaks', 'bowman-breaks': 'breaks' };
  var entry = ALIAS[(qs.get('focus') || '').toLowerCase()] || ALIAS[location.hash.replace('#', '').toLowerCase()] || 'overview';

  function track(ev, data) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: ev, rd_entry: entry, rd_page: PAGE_KEY }, k;
    for (k in UTM) o[k] = UTM[k];
    for (k in (data || {})) o[k] = data[k];
    window.dataLayer.push(o);
  }
  function withUtm(url) {
    if (!url || !Object.keys(UTM).length) return url;
    try {
      var u = new URL(url, location.origin);
      if (u.origin !== location.origin) return url;
      for (var k in UTM) if (!u.searchParams.has(k)) u.searchParams.set(k, UTM[k]);
      return u.pathname + u.search + u.hash;
    } catch (e) { return url; }
  }
  $$('a[data-out]').forEach(function (a) { a.href = withUtm(a.getAttribute('href')); });

  var stamped = false;
  function stampCart() {
    if (stamped) return Promise.resolve(); stamped = true;
    var attrs = { _rd_entry: entry, _rd_page: PAGE_KEY };
    for (var k in UTM) attrs['_rd_' + k] = UTM[k];
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }

  /* ── Toast ── */
  var toastEl = $('#toast'), toastT;
  function toast(m) {
    if (!toastEl) return;
    toastEl.textContent = m; toastEl.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2800);
  }
  function refreshCartUI(open) {
    // Eurus keeps its cart badge + drawer in Alpine stores; re-render them, then open the drawer
    try {
      var mini = window.Alpine && Alpine.store && Alpine.store('xMiniCart');
      if (mini) { mini.reLoad(); if (open) setTimeout(function () { mini.openCart(); }, 600); }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }
  function addItems(items) {
    return stampCart().then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
  }

  /* ── Sealed product cards ── */
  var PILL = {
    online: '<span class="st st--online">In stock online</span>',
    onlineOnly: '<span class="st st--online">Online now</span>',
    sold: '<span class="st st--sold">Sold out online</span>'
  };
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-add][data-variant]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    addItems([{ id: parseInt(btn.dataset.variant, 10), quantity: 1 }]).then(function () {
      toast((btn.dataset.label || 'Item') + ' added to cart');
      track('rd_add_to_cart', { release_item: btn.dataset.label || '' });
      refreshCartUI(true);
    }).catch(function () {
      toast('Could not add. It may have just sold out.');
      refreshProducts();
    }).then(function () { btn.disabled = false; });
  });

  function applyLive(card, prod) {
    var status = card.dataset.status;
    if (status === 'coming_soon' || status === 'store_only') return;
    var v = (prod.variants || []).filter(function (x) { return x.available; })[0] || (prod.variants || [])[0];
    if (!v) return;
    var pill = $('[data-pill]', card), price = $('[data-price]', card), btn = $('[data-add]', card);
    if (btn && btn.tagName === 'A') {
      var nb = document.createElement('button'); nb.type = 'button'; nb.className = btn.className;
      nb.setAttribute('data-add', ''); btn.replaceWith(nb); btn = nb;
    }
    var avail = !!prod.available;
    if (card.classList.contains('cfg')) card.classList.toggle('is-sold', !avail);
    if (pill) pill.innerHTML = avail ? (status === 'online_only' ? PILL.onlineOnly : PILL.online) : PILL.sold;
    if (price) price.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
    if (btn) {
      btn.disabled = !avail;
      btn.dataset.variant = v.id;
      if (!btn.dataset.label) btn.dataset.label = ($('.cfg__fmt', card) || {}).textContent || 'Item';
      btn.textContent = avail ? (status === 'online_only' ? 'Order Online' : 'Add to Cart') : 'Sold Out';
    }
  }
  function refreshProducts() {
    $$('[data-handle]:not(.board)').forEach(function (card) {
      fetch('/products/' + card.dataset.handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) { applyLive(card, p); }).catch(function () {
          var pr = $('[data-price]', card); if (pr && /Loading/.test(pr.textContent)) pr.innerHTML = '<small>See product page</small>';
        });
    });
  }

  /* ── Break boards ── */
  var SEL = {}; // "boardIdx:variantId" → {id, price, abbr, brk}
  var boards = $$('.board[data-handle]');
  function boardTitle(b) { return (b.dataset.title || '').split('·')[0].trim() || 'Break'; }

  boards.forEach(function (b) {
    $$('.team', b).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var key = b.dataset.board + ':' + btn.dataset.variant;
        if (SEL[key]) { delete SEL[key]; btn.classList.remove('on'); }
        else { SEL[key] = { id: parseInt(btn.dataset.variant, 10), price: parseInt(btn.dataset.price, 10) || 0, abbr: btn.dataset.abbr, brk: boardTitle(b) }; btn.classList.add('on'); }
        refreshBar();
      });
    });
  });

  function paintBoard(b) {
    var teams = $$('.team', b), left = 0, min = Infinity;
    teams.forEach(function (t) {
      if (!t.disabled) { left++; var p = parseInt(t.dataset.price, 10); if (p && p < min) min = p; }
    });
    var l = $('[data-left]', b), m = $('[data-meter]', b), f = $('[data-from]', b);
    if (l) l.textContent = left;
    if (m) m.style.width = Math.round((teams.length - left) / Math.max(teams.length, 1) * 100) + '%';
    if (f) f.textContent = left ? (min < Infinity ? 'Starting at ' + money(min) : left + ' open') : 'Board full';
    b.classList.toggle('is-full', left === 0);
    var mini = $('[data-mini="' + b.dataset.board + '"] [data-mini-left]'); if (mini) mini.textContent = left;
    return left;
  }
  function paintSummary() {
    var total = 0; boards.forEach(function (b) { total += parseInt(($('[data-left]', b) || {}).textContent, 10) || 0; });
    var s = $('[data-brk-summary]'); if (s && boards.length) s.textContent = total + ' teams open';
  }
  function refreshBoards() {
    boards.forEach(function (b) {
      fetch('/products/' + b.dataset.handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (prod) {
          var byId = {}; (prod.variants || []).forEach(function (v) { byId[v.id] = v; });
          $$('.team', b).forEach(function (t) {
            var v = byId[t.dataset.variant]; if (!v) return;
            var avail = !!v.available;
            t.disabled = !avail; t.classList.toggle('sold', !avail);
            t.setAttribute('aria-disabled', avail ? 'false' : 'true');
            t.dataset.price = v.price;
            $('.pr', t).textContent = avail ? money(v.price) : '—';
            var key = b.dataset.board + ':' + t.dataset.variant;
            if (!avail && SEL[key]) { delete SEL[key]; t.classList.remove('on'); }
          });
          paintBoard(b); paintSummary(); refreshBar();
        }).catch(function () {});
    });
  }

  var bar = $('#bar');
  function refreshBar() {
    if (!bar) return;
    var keys = Object.keys(SEL), total = 0;
    keys.forEach(function (k) { total += SEL[k].price; });
    $('#barCount').textContent = keys.length;
    $('#barTotal').textContent = money(total);
    $('#barTeams').textContent = keys.map(function (k) { return SEL[k].brk.replace('Break ', 'B') + ' ' + SEL[k].abbr; }).join(' · ');
    bar.classList.toggle('on', keys.length > 0);
  }
  var barAdd = $('#barAdd');
  if (barAdd) barAdd.addEventListener('click', function () {
    var keys = Object.keys(SEL); if (!keys.length) return;
    barAdd.disabled = true;
    addItems(keys.map(function (k) { return { id: SEL[k].id, quantity: 1 }; })).then(function () {
      track('rd_add_to_cart', { release_item: 'breaks', teams: keys.length });
      toast(keys.length + ' team spot(s) added. Heading to cart.');
      setTimeout(function () { location.href = withUtm(CART_URL); }, 800);
    }).catch(function () {
      toast('A team may have just sold. Board refreshed, please retry.');
      refreshBoards(); barAdd.disabled = false;
    });
  });

  /* ── Countdown ── */
  var bt = root.dataset.breakTime, cd = $('#cd');
  if (bt && cd && !isNaN(Date.parse(bt))) {
    var end = Date.parse(bt); cd.hidden = false;
    var tick = function () {
      var d = Math.max(0, end - Date.now());
      if (!d) { cd.hidden = true; var w = $('[data-brk-time]'); if (w) w.textContent = 'Live now'; clearInterval(iv); return; }
      $('#cdH').textContent = Math.floor(d / 3600000);
      $('#cdM').textContent = String(Math.floor(d / 60000) % 60).padStart(2, '0');
      $('#cdS').textContent = String(Math.floor(d / 1000) % 60).padStart(2, '0');
    };
    var iv = setInterval(tick, 1000); tick();
  }

  /* ── In-page navigation (keeps ?utm & ?focus intact) ── */
  function go(id, smooth) {
    var el = document.getElementById(id); if (!el) return;
    el.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    history.replaceState(null, '', location.pathname + location.search + '#' + id);
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]'); if (!a) return;
    var id = a.getAttribute('href').slice(1); if (!id || !document.getElementById(id)) return;
    e.preventDefault(); go(id, true);
    if (a.dataset.jump || a.dataset.nav) track('rd_jump', { to: id });
  });

  var navLinks = $$('.qnav a');
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.id;
        navLinks.forEach(function (a) { a.classList.toggle('on', a.dataset.nav === id); });
        var on = $('.qnav a.on'); if (on) on.parentNode.scrollTo({ left: on.offsetLeft - 12, behavior: 'smooth' });
        if (!seen[id]) { seen[id] = 1; track('rd_section_view', { section: id }); }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    $$('[data-release]').forEach(function (s) { io.observe(s); });
  }

  if (entry !== 'overview') {
    var touched = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function () { touched = true; }, { once: true, passive: true }); });
    var land = function () { if (!touched) go(entry, false); };
    land();
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(function () { requestAnimationFrame(land); });
    window.addEventListener('load', function () { setTimeout(land, 50); }, { once: true });
  }
  track('rd_landing', {});

  /* ── Live refresh ── */
  boards.forEach(paintBoard); paintSummary();
  refreshProducts(); refreshBoards();
  setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    refreshProducts(); refreshBoards();
  }, POLL);
})();
